import React from 'react'
import { useContent } from '../../contexts/ContentContext'
import SectionWrapper from '../ui/SectionWrapper'

export default function ServicesSection() {
  const { services } = useContent()

  return (
    <SectionWrapper id="services" data-testid="services-section" noSnap className="!py-2 md:!py-6">
        <div className="grid grid-cols-1 md:grid-cols-3 items-stretch text-center md:text-left">
          {services.items.map((service, i) => (
            <div
              key={i}
              className="py-1 md:py-2 md:px-4 flex flex-col justify-center md:border-l md:first:border-l-0 border-color-primary"
              data-testid={`service-item-${i}`}
            >
              <span className="typography-label">
                {service.sub}
              </span>
              <span className="typography-h3-mobile sm:typography-h4">
                {service.label}
              </span>
            </div>
          ))}
        </div>
    </SectionWrapper>
  )
}
